<ion-content class="ion-padding">
    <div class="content">
        <ion-label><b>{{ 'headEvaluation.reopen' | translate }}</b></ion-label>
        <ion-label>{{ 'headEvaluation.reopenConfirmation' | translate }}</ion-label>
        <p (click)="dismiss()">x</p>
    </div>
</ion-content>

<ion-footer>
    <ion-item>
        <ion-button mode="ios" size="default" fill="outline" color="danger" slot="start" (click)="dismiss()">
            {{ 'generic.cancel' | translate }}
        </ion-button>
        <ion-button mode="ios" size="default" color="primary" slot="end" (click)="dismiss(true)">
            {{ 'generic.confirm' | translate }}
        </ion-button>
    </ion-item>
</ion-footer>